































import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { axiosM } from "@/plugins/axios";
import AccountLoginCmp from "./accountLoginCmp.vue";
@Component({
  components: {
    AccountLoginCmp,
  },
})
export default class LoginView extends Vue {
  private window: any = window;
  private cState: "account" | "fast" = "account";

  /**
   * @description 前往注册
   */
  private goToRegister(): void {
    this.$router.push("/access/register");
  }
}
